// @flow
import React from 'react';
import ReactPlayer from 'react-player/lazy';

type Props = {
  url: String,
  size: String,
};

const YTVideo = ({ url, size }: Props) => (
  <ReactPlayer url={url} wrapper="div" width="100%" height={size} />
);

export default YTVideo;
